import { Flex, Divider } from "@chakra-ui/react";
import { useSettings } from "@/hooks";
import { useEffect, useState } from "react";
import { WithAuth } from "@/hoc";
import { GeneralInfo } from "./_GeneralInfo";
import { BankSlipConfig } from "./_BankSlipConfig";
import { PixConfig } from "./_PixConfig";
import { CreditCardConfig } from "./_CreditCardConfig";
import { showToast } from "@/utils";
import { ConfirmationModal } from "@/components/ConfirmationModal";
import { SellerNotifications } from "@/models";
import { Button, PageHeading, Tabs as BarteTabs, Tab as BarteTab } from "barte-design-system";
import { Tabs } from "@/components";
import { useNavigate } from "react-router-dom";


const Notifications = () => {
  const [data, setData] = useState({} as SellerNotifications);
  const [userData, setUserData] = useState(
    {} as Pick<
      SellerNotifications,
      "name" | "email" | "hiddenEmail" | "activeAllNotifications"
    >
  );
  const navigate = useNavigate();
  const [
    isEnableAllNotificationModalOpen,
    setIsEnableAllNotificationModalOpen,
  ] = useState(false);
  const [enableNotificationLoading, setEnableNotificationLoading] =
    useState(false);

  const {
    getSellerNotifications,
    handleBarChange,
    patchBasic,
    PIX,
    bank,
    info,
    credit,
  } = useSettings();

  const handleEnableAllNotifications = async () => {
    const sellerBasicData = {
      name: userData.name,
      email: userData.email,
      hiddenEmail: userData.hiddenEmail,
      activeAllNotifications: !data.activeAllNotifications,
    };
    try {
      setEnableNotificationLoading(true);
      await patchBasic(sellerBasicData);
      showToast({
        message: "Notificação desabilitada com sucesso",
        type: "success",
      });
    } catch (error) {
      error?.response?.data?.errors.map((error) => {
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`
        })
      });
    } finally {
      setEnableNotificationLoading(false);
      setIsEnableAllNotificationModalOpen(false);
    }
  };
  const getInitialData = async() => {
    try {
      const response = await getSellerNotifications();
      setData({ ...response.data });
      setUserData({
        name: response.data.name,
        email: response.data.email,
        hiddenEmail: response.data.hiddenEmail,
        activeAllNotifications: response.data.activeAllNotifications,
      });
    } catch (error) {
      showToast({
        type: "error",
        message: "Não foi possível carregar os dados básicos.",
      });
    }
  }
  useEffect(() => {
    getInitialData();
  }, [PIX, bank, info, credit, enableNotificationLoading]);


  const GeneralInfoContent = () => {
    return (
    <>
    <ConfirmationModal
      isOpen={isEnableAllNotificationModalOpen}
      onClose={() =>
        setIsEnableAllNotificationModalOpen(
          !isEnableAllNotificationModalOpen
        )
      }
      handleConfirmModal={() => handleEnableAllNotifications()}
      title={
        userData.activeAllNotifications === false
          ? "Ativar todas as notificações de cobrança?"
          : "Desativar todas as notificações de cobrança?"
      }
      isSubmitting={enableNotificationLoading}
    >
      {userData.activeAllNotifications === false
        ? "Seus clientes começarão a receber notificações relativas a cobranças conforme suas configurações por métodos de pagamento."
        : "Seus clientes não irão receber mais nenhuma notificação relativa a cobranças. Essa opção é recomendada somente em casos onde você já possui outro sistema de notificação fora da barte."}
    </ConfirmationModal>
    <GeneralInfo
      data={userData}
      refreshData={getInitialData}
    />
    <Divider my="2rem" />
    <Button
      variant={userData.activeAllNotifications === false ? "outline" : "fill"}
      style={{ maxWidth: "18rem" }}
      onClick={() =>
        setIsEnableAllNotificationModalOpen(
          !isEnableAllNotificationModalOpen
        )
      }
    >
      {userData.activeAllNotifications === false
        ? "Ativar notificações"
        : "Desativar todas as notificações"}
    </Button>
  </>
    )
  }
  const tabs = [
    { key: "generalInfo", label: "Informações gerais", content: <GeneralInfoContent /> },
    { key: "bankSlip", label: "Boleto", content: <BankSlipConfig data={data} /> },
    { key: "PIX", label: "Pix", content: <PixConfig data={data} /> },
    { key: "creditCard", label: "Cartão de Crédito", content: <CreditCardConfig data={data} /> },
  ];

  return (
    <>
      <Flex flexDir="column" gap="2rem">
      <PageHeading
        title="Notificações"
      />

      <Tabs 
        tabs={tabs.map((tab) => ({
          key: tab.key, 
          label: tab.label,
          content: tab.content
        }))} 
        onChange={(key) => handleBarChange(key)} 
        currentKey={info ? "generalInfo" : bank ? "bankSlip" : PIX ? "PIX" : "creditCard"} 
      />


   </Flex>
    </>
  );
};

export default WithAuth(Notifications);
